import { FC, MouseEvent } from 'react';
import { ToggleButton, ToggleButtonGroup } from '@mui/material';
import { ETLJobsTablesEnum } from '../types';

interface ETLJobsTableToggleProps {
  selectedTable: ETLJobsTablesEnum;
  onToggleButtonGroupChange: (event: MouseEvent<HTMLElement>, newSelectedTable: ETLJobsTablesEnum) => void;
}

const ETLJobsTableToggle: FC<ETLJobsTableToggleProps> = ({ selectedTable, onToggleButtonGroupChange }) => {
  return (
    <ToggleButtonGroup value={selectedTable} exclusive onChange={onToggleButtonGroupChange}>
      <ToggleButton value={ETLJobsTablesEnum.SCHEDULED_JOBS}>Scheduled Jobs</ToggleButton>
      <ToggleButton value={ETLJobsTablesEnum.JOB_HISTORY}>Job History</ToggleButton>
    </ToggleButtonGroup>
  );
};

export default ETLJobsTableToggle;
